<p>loader works!</p>
<div class="loader-overlay">
  <div class="loader"></div>
</div>
